// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper_Wrapper__1-8t3","center":"Wrapper_center__2oDcV"};